import { PageBlockType } from "@next-platform/packages-ts-types";
import { useCallback } from "react";
import loadDiscoveryRecommendationRow, {} from "./loadDiscoveryRecommendationRow";
import loadPageBlockRowContent from "./loadPageBlockRowContent";
export default function useLoadBlockRowContent({ refBlocks, refContext, refRecommendation, refRecommendationListeners, refAutoRetryMap, handleLoadResult, retryRow, }) {
    return useCallback(async (blockKey, signal) => {
        const block = refBlocks.current.find((candidate) => candidate.key === blockKey);
        const requestContext = { ...refContext.current };
        if (!block || requestContext.applicationId === null)
            return;
        const result = block.type === PageBlockType.Recommendation
            ? await loadDiscoveryRecommendationRow({
                signal,
                readRecommendation: () => refRecommendation.current,
                listeners: refRecommendationListeners.current,
            })
            : await loadPageBlockRowContent({
                applicationId: requestContext.applicationId,
                pageKey: requestContext.pageKey,
                blockKey,
                isNsfw: requestContext.isNsfw,
                signal,
                isAutoRetryAllowed: !refAutoRetryMap.current.get(blockKey),
            });
        await handleLoadResult(block, signal, retryRow, requestContext)(result);
    }, [refBlocks, refContext, refRecommendation, refRecommendationListeners, refAutoRetryMap, handleLoadResult, retryRow]);
}
